import PageSearch from 'components/search';
import Layout from 'components/layout';
import { reformatLocaleToContentfulLocale } from 'lib/utils/helpers';
import { getGlobal } from 'lib/contentful';
import Head from 'next/head';
import { useSalons } from 'hooks';

export default function Page({ locale, globalModules }) {
  useSalons(locale);

  return (
    <Layout locale={locale} globalModules={globalModules}>
      <Head>
        <title>{globalModules.search?.search?.text} | Keune Haircosmetics</title>
      </Head>
      <PageSearch
        locale={locale}
        resources={[
          globalModules.search,
          globalModules.settings,
          globalModules.productpage,
          globalModules.secondsearchpart,
          globalModules.secondpartsettings,
        ]}
      />
    </Layout>
  );
}

export async function getStaticProps({ locale }) {
  const globalModules = await getGlobal(
    [
      'search',
      'secondsearchpart',
      'productpage',
      'cookies',
      'announcement-bar',
      'firstcountryselectorlocales',
    ],
    reformatLocaleToContentfulLocale(locale)
  );

  return {
    props: { locale, globalModules },
  };
}
